// from general.js
/* global Uri dcAnalytics getTrackingLink getTafEmail isMobileView */
// from JSP?
/* global shareURL */

import { redirectToSmsWithShortenedUrl, redirectToTwitterWithShortenedUrl } from './sharebarHelperFunctions.js';
import { removeHTMLTagsAndIEStyleNewLines } from '../utils/stringUtils.ts';

// TODO update the usages of this case to use non-global exports

function decorateWithOgTitle(elem, link) {
    let ogTitle = $(elem).attr('data-og-title');
    if (ogTitle) {
        ogTitle = removeHTMLTagsAndIEStyleNewLines(ogTitle);
        link = (new Uri(link)).replaceQueryParam('ogTitle', ogTitle);
    }
    return link;
}

const onClickEmailShare = function (elem, entityURL) {
    dcAnalytics.trackShareToolClick(pageName, entityURL, 'TellAFriend');
};

export const onClickFacebookShare = window.onClickFacebookShare = function (elem, entityURL) {
    dcAnalytics.trackShareToolClick(pageName, entityURL, 'Facebook');
    const pageSource = $(elem).attr('data-page-source');
    let link = decodeURIComponent(getTrackingLink(entityURL, 'facebook', pageSource));
    link = decorateWithOgTitle(elem, link);
    elem.href = (new Uri(elem.href)).replaceQueryParam('href', link).replaceQueryParam('link', link).toString();
};

const onClickNextdoorShare = function (elem, entityURL) {
    dcAnalytics.trackShareToolClick(pageName, entityURL, 'Nextdoor');
    const pageSource = $(elem).attr('data-page-source');
    let link = decodeURIComponent(getTrackingLink(entityURL, 'nextdoor', pageSource));
    link = decorateWithOgTitle(elem, link);
    elem.href = (new Uri(elem.href)).replaceQueryParam('href', link).replaceQueryParam('link', link).toString();
};

const onClickMessengerShare = function (elem, entityURL) {
    dcAnalytics.trackShareToolClick(pageName, entityURL, 'Facebook Messenger');
    const pageSource = $(elem).attr('data-page-source');
    let link = decodeURIComponent(getTrackingLink(entityURL, 'fbmessenger', pageSource));
    link = decorateWithOgTitle(elem, link);
    if (isMobileView()) {
        elem.href = (new Uri('fb-messenger://share/')).replaceQueryParam('app_id', facebookAppId).replaceQueryParam('link', link).toString();
    } else {
        elem.href = (new Uri(elem.href)).replaceQueryParam('link', link).replaceQueryParam('redirect_uri', link).toString();
    }
};

export const onClickTwitterShare = window.onClickTwitterShare = function (elem, entityURL, shortenUrl) {
    dcAnalytics.trackShareToolClick(pageName, entityURL, 'Twitter');
    const pageSource = $(elem).attr('data-page-source');
    const link = decodeURIComponent(getTrackingLink(entityURL, 'twitter', pageSource));
    if (shortenUrl) {
        redirectToTwitterWithShortenedUrl(elem.href, link);
    } else {
        elem.href = (new Uri(elem.href)).replaceQueryParam('href', link).replaceQueryParam('link', link).toString();
    }
    return false;
};

export const onClickLinkShare = function (elem, entityURL) {
    dcAnalytics.trackShareToolClick(pageName, entityURL, 'directlink');
    const pageSource = $(elem).attr('data-page-source');
    let link = decodeURIComponent(getTrackingLink(entityURL, 'directlink', pageSource));
    link = decorateWithOgTitle(elem, link);
    elem.href = link;

    const tempInput = $("<input type='text'>");
    const pageURL = elem.href;

    $('body').append(tempInput);
    tempInput.val(pageURL).select();
    document.execCommand('copy');
    tempInput.remove();

    $('.copylink-popup').css('display', 'block');
    $('.mobile.share-buttons .copylink-popup').css('display', 'block');
    $('.project-url').addClass('copied');

    setTimeout(function () {
        $('.copylink-popup').css('display', 'none');
        $('.mobile.share-buttons .copylink-popup').css('display', 'none');
        $('.project-url').removeClass('copied');
    }, 2500);
};

const onClickSmsShare = function (elem, entityURL, shortenUrl) {
    dcAnalytics.trackShareToolClick(pageName, entityURL, 'SMS');
    if (shortenUrl) {
        const href = $('.js-share-sms').attr('href'); // contains both sms text and link
        const prefix = href.substring(0, href.indexOf('body=') + 5);
        const text = href.substring(href.indexOf('body=') + 5, href.indexOf('http'));
        const pageSource = $(elem).attr('data-page-source');
        const link = decodeURIComponent(getTrackingLink(entityURL, 'sms', pageSource));
        const fullUrl = prefix + text + link;
        redirectToSmsWithShortenedUrl(fullUrl, link);
        return false;
    } else {
        /**  Oct 2017: Don't decorate with RF or UTM params for now since it looks messy
         * elem.href= prefix + text + link;
         */
    }
    return true;
};

const onClickMobileShareTrayShare = function (elem, entityURL) {
    dcAnalytics.trackShareToolClick(pageName, entityURL, 'Mobile Share Tray');
    const pageSource = $(elem).attr('data-page-source');
    const link = decodeURIComponent(getTrackingLink(entityURL, 'mobilesharetray', pageSource));
    elem.href = (new Uri(elem.href)).replaceQueryParam('url', link).toString();

    navigator.share({
        text: 'a',
        url: link,
    });
};

export const setNextdoorLink = () => {
    const teacherLinks = document.getElementsByClassName('js-teacher-link');
    const teacherSchools = document.getElementsByClassName('js-teacher-school');
    if (pageName == 'school_info' || pageName == 'district_info') {
        const schoolName = $(".js-entity-name")[0].innerText;
        const intro = `Hi! I'm a neighbor here looking to get support for ${schoolName}: `;
        const body = encodeURIComponent(intro);
        const paramLinks = getTrackingLink(shareURL, 'nextdoor', pageName);
        const nextDoorLink = `https://nextdoor.com/sharekit/?source=DonorsChoose&hashtag=fundraising&body=${body}` + paramLinks;
        $('.js-share-nextdoor').attr('href', nextDoorLink);
        return ({ nextDoorLink });
    } else if (pageName == 'teacher_profile') {
        const teacherName = document.getElementsByClassName('js-teacher-name-possessive')[0].innerText;
        const intro = `Hi! I'm a neighbor here looking to get support for ${teacherName} classroom: `;
        const body = encodeURIComponent(intro);
        const paramLinks = getTrackingLink(shareURL, 'nextdoor', pageName);
        const nextDoorLink = `https://nextdoor.com/sharekit/?source=DonorsChoose&hashtag=fundraising&body=${body}` + paramLinks;
        $('.js-share-nextdoor').attr('href', nextDoorLink);
        return ({ nextDoorLink });
    } else if (pageName == 'givingpage') {
        const givingPageName = document.getElementById('challengeNameDisplay').innerText;
        const intro = `Hi! I'm a neighbor here looking to get support for ${givingPageName}: `;
        const body = encodeURIComponent(intro);
        const paramLinks = getTrackingLink(shareURL, 'nextdoor', pageName);
        const nextDoorLink = `https://nextdoor.com/sharekit/?source=DonorsChoose&hashtag=fundraising&body=${body}` + paramLinks;
        $('.js-share-nextdoor').attr('href', nextDoorLink);
        return ({ nextDoorLink });
    } else {
        if (teacherLinks.length === 0 || teacherSchools.length === 0) {
            // The only build-a-Nextdoor-link code we have relies on these elements - on pages where they don't exist
            // (like the school page), just bail out instead.
            return;
        }
        const teacherName = teacherLinks[0].innerText;
        const teacherSchool = teacherSchools[0].innerText;
        const intro = `Hi! I'm a neighbor here looking to get support for ${teacherName}, a teacher at ${teacherSchool}. Here's more information from ${teacherName}:\n\n`;
        const essay = '"' + document.getElementsByClassName('js-about-project')[0].innerText + '"';
        const outro = '\n\nSupport this classroom here: ';
        const body = encodeURIComponent(intro + essay + outro);
        const paramLinks = getTrackingLink(shareURL, 'nextdoor', pageName);
        const nextDoorLink = `https://nextdoor.com/sharekit/?source=DonorsChoose&hashtag=fundraising&body=${body}` + paramLinks;
        $('.js-share-nextdoor').attr('href', nextDoorLink);
        return({nextDoorLink});
    }
};

$(document).ready(function () {
    $(document).on('click', '.js-share-email', function (e) {
        onClickEmailShare(pageName, shareURL);
        getTafEmail(pageName, this, shareURL);
        e.preventDefault();
    });
    $(document).on('click', '.js-share-facebook', function () {
        onClickFacebookShare(this, shareURL);
    });

    setNextdoorLink();

    $(document).on('click', '.js-share-nextdoor', function (e) {
        onClickNextdoorShare(this, shareURL);
    });
    $(document).on('click', '.js-share-messenger', function () {
        onClickMessengerShare(this, shareURL);
    });
    $(document).on('click', '.js-share-twitter', function () {
        return onClickTwitterShare(this, shareURL, true);
    });
    $(document).on('click', '.js-share-tray', function (e) {
        e.preventDefault();
        onClickMobileShareTrayShare(this, shareURL);
    });
    $(document).on('click', '.js-share-link', function (e) {
        e.preventDefault();
        onClickLinkShare(this, shareURL);
    });
    $(document).on('click', '.js-project-url', function () {
        onClickLinkShare(this, shareURL);
        this.select();
    });
    if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
        // some of the sms buttons are being added by handlebars templates at unpredictable times; the stylesheet covers those cases too.
        // once handlebar templates are swapped for react, this line can be removed.
        $('head').append('<style type="text/css">.share-buttons .button-secondary.button-sms {display: none ! important}</style>');
    }
    $(document).on('click', '.js-share-sms', function () {
        // for now, do not shorten URL for SMS shares
        onClickSmsShare(this, shareURL, false);
    });
});
